export default __webpack_public_path__ + "static/media/logo-white.0c6b37f9.png";